'use client';

import { useProduct } from '@/entities/product';
import { usePurchaseFormWatch } from '@/entities/purchase-form';

const titles = {
    bopis: 'Pick up today',
    sdd: 'Delivered today',
    sth: 'Delivered in 1-3 days',
};

export const ImmediateDeliveryTitle = () => {
    const { product, tailored } = useProduct();

    const deliveryMethod = usePurchaseFormWatch('fulfilmentMethod');
    const immediateTitle = titles[deliveryMethod ?? 'bopis'];

    const storeId = tailored?.variants?.[product?.sku ?? '']?.BOPIS?.storeId;
    const store = tailored?.bopisStoreData?.[storeId ?? '']?.storeDetails;

    if (deliveryMethod === 'bopis' && store) {
        return (
            <span>
                {immediateTitle} <span className="weight-normal">at {store.name}</span>
            </span>
        );
    }

    return immediateTitle;
};
